import { put } from 'redux-saga/effects';
import api from '../api';
import {
    fetchNotificationsSuccess,
    fetchNotificationsFail
} from '../actions';

export function* fetchNotifications({ partnerID, userID }) {
  try {
    const response = yield api.notifications.getNotifications(partnerID, userID);
    yield put(fetchNotificationsSuccess(response.data.data.notifications));
  } catch (error) {
    yield put(fetchNotificationsFail(error));
  }
}